module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/share-cfbbcaca5f691f7f43e1e14bc5b6f13c.svg";